import { filter, map, switchMap } from "rxjs/operators";
import { createLoaderEventToActionMapper } from "./createLoaderEventToActionMapper";
export var createEpicLoading = function (triggerActionFilter, id, bundle) { return function (action$, state$, deps) {
    return action$.pipe(filter(triggerActionFilter), switchMap(function () {
        return deps.utilLoader.load(id, bundle).pipe(map(createLoaderEventToActionMapper(id)));
    }));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/loading/createEpicLoading.ts
// module id = 1985
// module chunks = 3